import React from "react";
import clsx from "clsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grow from "@material-ui/core/Grow";
import useStyles from "./styles";

const Error = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CssBaseline />
      <div className={classes.container}>
        <Typography variant="h1" color="inherit" className={clsx(classes.fontMedium, classes.mb16)}>
          500
        </Typography>

        <Grow in={true} timeout={600}>
          <Typography variant="h5" color="inherit" className={classes.mb16}>
            Well, you broke the internet!
          </Typography>
        </Grow>

        <Grow in={true} timeout={800}>
          <Typography variant="subtitle1" color="inherit" className={classes.mb16}>
            Just kidding, looks like we have an internal issue, please try again in couple minutes
          </Typography>
        </Grow>

        {/* <a href="mailto:developer@baristastation.app" className={classes.fontMedium}>
          Report this problem
        </a> */}
      </div>
    </div>
  );
};

export default Error;
